<ngx-loading-bar [includeSpinner]="false" height="4px" color="#FF0000"></ngx-loading-bar>
<div class="version" [routerLink]="['/releasenotes']" [ngClass]="this.releasenotes !== this.App_Version ? 'version_blink' : ''" >{{ this.App_Version }}@if (this.releasenotes !== this.App_Version) {
  <span>&nbsp;&nbsp;&nbsp;klick mich</span>
}</div>
<div class="views">
  <div class="view view-main">
    <div class="pages">
      <div data-page="index" class="page homepage" id="menu_background" style="z-index: 1">
        <div class="page-content">
          <div class="logo">
            <h1>{{ this.Ueberschrift }}</h1>
            <span class="rotertext"><h1>{{ this.Hinweis }}</h1></span>
          </div>
          <nav class="main-nav">
            <ul>
              @for (Item of MenuItems; track Item) {
                <li>
                  @if (Item.href != '/dummy') {
                    <div [routerLink]="[Item.href]">
                      <a>
                        <img src="./assets/images/icons/blue/{{Item.image}}.png" alt=""
                          title=""/><span>{{Item.bebschreibung}}</span>
                          @if (Item.newsitems > 0) {
                            <div class="cartitems">{{Item.newsitems}}</div>
                          }
                          @if (Item.newsitems_red > 0) {
                            <div class="cartitems_red">{{Item.newsitems_red}}
                            </div>
                          }
                        </a>
                      </div>
                    }
                    @if (Item.href == '/dummy') {
                      <div
                        onclick="alert('Lieber Nutzer, auf diesen Bereich haben nur unsere Mitglieder Zugriff - wir bitten um Verständnis !');">
                      <a>
                        <img src="./assets/images/icons/blue/{{Item.image}}.png" alt=""
                          title=""/><span>{{Item.bebschreibung}}</span>
                          @if (Item.newsitems > 0) {
                            <div class="cartitems">{{Item.newsitems}}</div>
                          }
                          @if (Item.newsitems_red > 0) {
                            <div class="cartitems_red">{{Item.newsitems_red}}
                            </div>
                          }
                        </a>
                      </div>
                    }
                  </li>
                }
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
